import type { ReactNode } from 'react'
import { usePageTitle } from '../lib/usePageTitle'
import styles from './Page.module.css'

/** Standard page frame: title row + content, 20–24px padding. */
export function Page({ title, subtitle, actions, children, wide = false }: {
  title: string; subtitle?: ReactNode; actions?: ReactNode; children: ReactNode; wide?: boolean
}) {
  usePageTitle(title)
  return (
    <div className={`${styles.page} ${wide ? styles.wide : ''}`}>
      <div className={styles.head}>
        <div className={styles.titles}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {children}
    </div>
  )
}
